export enum HIERARCHY_CATEGORY {
  digitalVault = 'Digital Vault',
}
